import PropTypes from "prop-types";
import React from "react";
import I18n from "i18n-js";

import { StyleSheet, View, Text, TouchableOpacity } from "react-native";
import { connect } from "react-redux";

import fonts from "../constants/fonts";
import staticColors from "../constants/staticColors";

class PrescriptionHistoryDetail extends React.Component {
  static propTypes = {
    data: PropTypes.shape({
      id: PropTypes.string.isRequired,
      prescriptionNo: PropTypes.string,
      lifepackSubscriptionId: PropTypes.string,
      patientName: PropTypes.string.isRequired,
      patientClass: PropTypes.string,
      status: PropTypes.string,
      prescriptionDate: PropTypes.string,
      lifepack: PropTypes.object,
    }),
    navigation: PropTypes.object.isRequired,
  };

  state = { isLoading: true };

  componentDidMount() {
    this.props.navigation.addListener("willFocus", () => {
      console.info("willFocus");
      this.setState({ isLoading: true });
    });
    this.props.navigation.addListener("didFocus", () => {
      console.info("didFocus");
      this.setState({ isLoading: false });
    });
    this.props.navigation.addListener("willBlur", () =>
      console.info("willBlur")
    );
    this.props.navigation.addListener("didBlur", () => {
      console.info("didBlur");
      this.setState({ isLoading: false });
    });
  }
  goToHistoryDetail = (data) => {
    const { navigation } = this.props;
    const { cardNumber, fullName, gender } = navigation.state.params;
    navigation.navigate("PrescriptionHistoryDetail", {
      data,
      cardNumber,
      fullName,
      gender,
    });
  };

  goToPrescriptionDetail = (data) => {
    const { navigation } = this.props;
    const { cardNumber, fullName, gender, config } = navigation.state.params;
    navigation.navigate("PrescriptionDetail", {
      prescriptionId: data.id,
      customerName: fullName,
      patientName: data.patientName,
      cardNumber: cardNumber,
      gender: gender,
      pharmacy: config.pharmacy,
    });
  };

  render() {
    const { data, themeColors, navigation } = this.props;
    return (
      <View>
        <View style={styles.container}>
          <View style={styles.detailContainer}>
            <Text style={styles.regularBold}>{data.patientName}</Text>
            <Text
              style={[
                styles.section,
                { marginTop: 5, color: staticColors.grey },
              ]}
            >
              {I18n.t("prixa.lifepackSubscriptionIdWithNumber", {
                no: data.lifepackSubscriptionId,
              })}
            </Text>
            {!!data.status ? (
              navigation.state.params.config.pharmacy.pharmacy_name ===
              "Siloam" ? (
                <Text
                  style={[
                    styles.regular,
                    {
                      marginTop: 5,
                      color: themeColors.primary,
                      ...fonts.bold,
                      textTransform: "capitalize",
                    },
                  ]}
                >
                  {I18n.t("prixa.defaultStatusDelivery")}
                </Text>
              ) : (
                <Text
                  style={[
                    styles.regular,
                    {
                      marginTop: 5,
                      color: themeColors.primary,
                      ...fonts.bold,
                      textTransform: "capitalize",
                    },
                  ]}
                >
                  {I18n.t("prixa.prescriptionStatusDelivery", {
                    status: data.status,
                  })}
                </Text>
              )
            ) : null}
          </View>
        </View>
        <View style={styles.buttonContainer}>
          {navigation.state.params.config.is_pharmacy_enabled == true &&
          !!data.status ? (
            <TouchableOpacity
              onPress={() => this.goToHistoryDetail(data)}
              style={{ marginTop: 20 }}
            >
              <View
                style={{
                  borderRadius: 20,
                  backgroundColor: staticColors.forestFern,
                }}
              >
                <Text
                  style={{
                    fontSize: 11,
                    ...fonts.bold,
                    color: "#fff",
                    width: 110,
                    textAlign: "center",
                    paddingVertical: 9,
                    textTransform: "uppercase",
                  }}
                >
                  {I18n.t("prixa.prescriptionView")}
                </Text>
              </View>
            </TouchableOpacity>
          ) : null}
          <TouchableOpacity
            onPress={() => this.goToPrescriptionDetail(data)}
            style={{ marginTop: 20, marginLeft: 10 }}
          >
            <View
              style={{
                borderRadius: 20,
                borderColor: staticColors.forestFern,
                borderWidth: 2,
              }}
            >
              <Text
                style={{
                  fontSize: 11,
                  ...fonts.bold,
                  color: staticColors.forestFern,
                  width: 120,
                  textAlign: "center",
                  paddingVertical: 7,
                  textTransform: "uppercase",
                }}
              >
                {!!data.status
                  ? I18n.t("prixa.prescriptionDetail")
                  : I18n.t("prixa.prescriptionRedeem")}
              </Text>
            </View>
          </TouchableOpacity>
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
  },
  buttonContainer: {
    marginTop: 10,
    justifyContent: "flex-end",
    flexDirection: "row",
    flex: 1,
    paddingLeft: 40,
  },
  detailContainer: {
    flex: 1,
    paddingRight: 8,
  },
  section: {
    fontSize: 12,

    ...fonts.regular,
  },
  regular: {
    fontSize: 13,

    ...fonts.regular,
  },
  regularBold: {
    fontSize: 13,
    ...fonts.bold,
    color: "#000",
  },
});

export default connect((state) => ({
  themeColors: state.themeColors,
}))(PrescriptionHistoryDetail);
